import { Step } from '../../../../../views/alerts/PendingOrderAlertScreen';
import { BackendErrorCode, OrderMethod } from '../../../../../services/exports/Constants';

export default {
  steps: {
    [Step.OrderPreview]: {
      titles: {
        asap: 'Ny {{method}}-ordre!',
        scheduled: 'Planlagt {{method}}-ordre!',
        on_site: 'Ny bordbestilling!',
        // Table orders are ASAP; this is for room-service orders scheduled before the rename.
        on_site_scheduled: 'Planlagt bordordre!',
      },
      labels: {
        today: 'i dag',
        time_remaining_to_accept: 'tilbage til at acceptere',
      },
      time_tag: {
        [OrderMethod.Pickup]: {
          asap: '🕓 Afhentning om {{time}}',
          scheduled: '🕓 Afhentning {{day}} kl. {{time}}',
          scheduled_today: '🕓 Afhentning i dag kl. {{time}}',
        },
        [OrderMethod.Delivery]: {
          asap: '🕓 Levering om {{time}}',
          scheduled: '🕓 Levering {{day}} kl. {{time}}',
          scheduled_today: '🕓 Levering i dag kl. {{time}}',
        },
        [OrderMethod.OnSite]: {
          // No 🕓: the screen draws the design's clock icon for table orders.
          asap: 'Servering om {{from}}–{{to}} min.',
          scheduled: 'Servering {{day}} kl. {{time}}',
          scheduled_today: 'Servering i dag kl. {{time}}',
        },
      },
      time_tag_estimated: {
        asap: '🕓 Omtrentlig afhentningstid: {{time}}',
        scheduled: '🕓 Omtrentlig afhentningstid: {{day}} kl. {{time}}',
      },
      buttons: {
        confirm_order: 'Bekræft ordre',
        cancel_order: 'Annuller ordre',
      },
      feedback: {
        rough_estimate_warning:
          'Dette er kun et groft estimat. Du får den faktiske tilberedningstid, når en chauffør er tildelt, og leveringstiden er bekræftet. På det tidspunkt udskrives din bon automatisk.',
      },
    },
    [Step.OrderConfirmation]: {
      title: 'Tilberedningstid',
      labels: {
        today: 'i dag',
        order_time: {
          [OrderMethod.Delivery]: {
            asap: 'Levering om',
            scheduled: 'Levering den',
            scheduled_today: 'Levering',
          },
          [OrderMethod.Pickup]: {
            asap: 'Afhentning om',
            scheduled: 'Afhentning den',
            scheduled_today: 'Afhentning',
          },
          [OrderMethod.OnSite]: {
            asap: 'Servering om',
            scheduled: 'Servering den',
            scheduled_today: 'Servering',
          },
        },
        can_you_make_it: 'Kan du nå det?',
        we_also_send_this_update_to_the_customer: 'Vi sender også denne opdatering til kunden',
      },
      buttons: {
        yes_lets_go: 'Ja, kør!',
        no_change_time: 'Nej, ændr tid',
        confirm: 'Bekræft',
      },
      toasts: {
        order_confirmed: {
          title: 'Ordre #{{number}} bekræftet',
          body: 'Start ikke tilberedning endnu! Vi giver besked, når en chauffør er tildelt.',
        },
        [BackendErrorCode.NoDeliveryQuotesAvailable]:
          'Desværre skal leveringen annulleres, fordi chaufføren ikke er tilgængelig. Klik på de tre prikker øverst til højre for at annullere ordren og refundere pengene til kunden',
        [BackendErrorCode.DeliveryProviderException]:
          'Desværre skal leveringen annulleres, fordi chaufføren ikke er tilgængelig. Klik på de tre prikker øverst til højre for at annullere ordren og refundere pengene til kunden',
        [BackendErrorCode.DeliveryDispatchRetrying]:
          'Ordre accepteret, men ingen chauffør er booket endnu. Vi bliver ved i 15 minutter og giver besked, hvis ingen findes.',
      },
    },
  },
  error_messages: {
    something_went_wrong: 'Noget gik galt, prøv igen',
  },
};
